import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\RatePlans\OtaRateController::index
* @see app/Http/Controllers/Admin/RatePlans/OtaRateController.php:34
* @route '/ota-rates'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/ota-rates',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\RatePlans\OtaRateController::index
* @see app/Http/Controllers/Admin/RatePlans/OtaRateController.php:34
* @route '/ota-rates'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\RatePlans\OtaRateController::index
* @see app/Http/Controllers/Admin/RatePlans/OtaRateController.php:34
* @route '/ota-rates'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\RatePlans\OtaRateController::index
* @see app/Http/Controllers/Admin/RatePlans/OtaRateController.php:34
* @route '/ota-rates'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\RatePlans\OtaRateController::index
* @see app/Http/Controllers/Admin/RatePlans/OtaRateController.php:34
* @route '/ota-rates'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\RatePlans\OtaRateController::index
* @see app/Http/Controllers/Admin/RatePlans/OtaRateController.php:34
* @route '/ota-rates'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\RatePlans\OtaRateController::index
* @see app/Http/Controllers/Admin/RatePlans/OtaRateController.php:34
* @route '/ota-rates'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Admin\RatePlans\OtaRateController::calendar
* @see app/Http/Controllers/Admin/RatePlans/OtaRateController.php:95
* @route '/ota-rates/calendar'
*/
export const calendar = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: calendar.url(options),
    method: 'get',
})

calendar.definition = {
    methods: ["get","head"],
    url: '/ota-rates/calendar',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\RatePlans\OtaRateController::calendar
* @see app/Http/Controllers/Admin/RatePlans/OtaRateController.php:95
* @route '/ota-rates/calendar'
*/
calendar.url = (options?: RouteQueryOptions) => {
    return calendar.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\RatePlans\OtaRateController::calendar
* @see app/Http/Controllers/Admin/RatePlans/OtaRateController.php:95
* @route '/ota-rates/calendar'
*/
calendar.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: calendar.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\RatePlans\OtaRateController::calendar
* @see app/Http/Controllers/Admin/RatePlans/OtaRateController.php:95
* @route '/ota-rates/calendar'
*/
calendar.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: calendar.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\RatePlans\OtaRateController::calendar
* @see app/Http/Controllers/Admin/RatePlans/OtaRateController.php:95
* @route '/ota-rates/calendar'
*/
const calendarForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: calendar.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\RatePlans\OtaRateController::calendar
* @see app/Http/Controllers/Admin/RatePlans/OtaRateController.php:95
* @route '/ota-rates/calendar'
*/
calendarForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: calendar.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\RatePlans\OtaRateController::calendar
* @see app/Http/Controllers/Admin/RatePlans/OtaRateController.php:95
* @route '/ota-rates/calendar'
*/
calendarForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: calendar.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

calendar.form = calendarForm

const otaRates = {
    index: Object.assign(index, index),
    calendar: Object.assign(calendar, calendar),
}

export default otaRates